import { render } from "./MultiComponentRegisterView.vue?vue&type=template&id=243942c4&scoped=true"
import script from "./MultiComponentRegisterView.vue?vue&type=script&lang=js"
export * from "./MultiComponentRegisterView.vue?vue&type=script&lang=js"

import "./MultiComponentRegisterView.vue?vue&type=style&index=0&id=243942c4&scoped=true&lang=css"

import exportComponent from "C:\\Users\\javon\\mgs\\RabbitsfootOperatorApps\\playerpanel\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-243942c4"]])

export default __exports__